import { FunctionComponent, useContext } from 'react';
import { TextField, Typography } from '@mui/material';
import TFWithLabelAndLink from '../../components/TFWithLabelAndLink';
import { AppContext } from '../../providers/AppContext';
import About from '../../interfaces/AboutMe';
import useWindowDimensions from '../../hooks/dimension';

interface AboutMeProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const AboutMe: FunctionComponent<AboutMeProps> = (props: AboutMeProps) => {

    const { changeData, about } = useContext(AppContext);
    const { height, width } = useWindowDimensions();

    const onChange = (idx: number, attribute: keyof About, value: any) => {

        const newData = about.map((item, index) => {
            if (index === idx) {
                item[attribute] = value
            }
            return item
        })

        changeData({
            about: newData
        })

    }

    return (
        <div
            id={props.id}
            draggable={true}
            onDragStart={props.handleDrag}
            onDragOver={(e: any) => e.preventDefault()}
            onDrop={(e) => props.handleDrop(e, true)}
        >
            <Typography variant='h5' style={{
                marginBottom: 8,
            }}>About Me</Typography>

            {
                about.map((item: About, index: number) => {
                    return index !== (about.length - 1) ? (
                        <TFWithLabelAndLink
                            title={item.description}
                            label={item.value}
                            labelPlaceholder={item.placeholder}
                            link={item.link}
                            linkPlaceholder='Link'
                            id={index}
                            onChange={onChange}
                        />
                    ) : (
                        <div className={width && width > 600 ? 'inline-start' : 'column'}>
                            <Typography variant='body1' style={{ marginBottom: 8 }}>{item.description}</Typography>
                            <TextField id='outlined-basic' placeholder={item.placeholder} variant='standard' size='small' style={{
                                display: 'flex',
                                flex: 3, marginLeft: width && width < 600 ? 0 : 8, marginBottom: width && width < 600 ? 12 : 8, marginTop: width && width < 600 ? -8 : 0
                            }}
                                InputProps={{
                                    disableUnderline: true
                                }}
                                value={item.value}
                                onChange={(e) => onChange(index, 'value', e.target.value)}
                            />
                        </div>
                    )
                })
            }
        </div>
    );
}

export default AboutMe;